import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import NotFoundPage from '@/views/NotFoundPage.vue';
import TransactionView from '@/views/TransactionView.vue';
import BondSettingView from '@/views/BondSettingView.vue';
import UserSettingView from '@/views/UserSettingView.vue';
import SellView from '@/views/SellView.vue';

import store from '@/store';
import BuyView from '@/views/BuyView.vue';
import UncategorizedChatView from '@/views/UncategorizedChatView.vue';

import DashboardLayout from '@/layouts/DashboardLayout.vue';
import KtbView from '@/views/KtbView.vue';
import UserLogView from '@/views/UserLogView.vue';
import userService from '@/service/userService';
import NonBenchmarkView from '@/views/NonBenchmarkView.vue';
import YuantaView from '@/views/YuantaView.vue';
import SchedulerSettingView from '@/views/SchedulerSettingView.vue';
import MarketFlowView from '@/views/MarketFlowView.vue';

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/',
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'SellView',
        component: SellView,
        meta: { requiresAuth: true },
      },
      {
        path: '/non-benchmark',
        name: 'NonBenchmarkView',
        component: NonBenchmarkView,
        meta: { requiresAuth: true },
      },
      {
        path: '/transaction',
        name: 'TransactionView',
        component: TransactionView,
        meta: { requiresAuth: true },
      },
      {
        path: '/buy',
        name: 'BuyView',
        component: BuyView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/uncategorized',
        name: 'UncategorizedChatView',
        component: UncategorizedChatView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/setting/bond',
        name: 'BondSettingView',
        component: BondSettingView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/setting/user',
        name: 'UserSettingView',
        component: UserSettingView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/ktb',
        name: 'KtbView',
        component: KtbView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/logs',
        name: 'UserLogView',
        component: UserLogView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/setting/scheduler',
        name: 'SchedulerSettingView',
        component: SchedulerSettingView,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/yuanta',
        name: 'YuantaView',
        component: YuantaView,
        meta: { requiresAuth: true },
      },
      {
        path: '/market-flow',
        name: 'MarketFlowView',
        component: MarketFlowView,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: NotFoundPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const isAdmin = store.getters['auth/isAdmin'];

  // 인증이 필요한 페이지에 대해서만 권한 체크
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next({ name: 'LoginPage' });
    }

    try {
      // 권한 체크 API 호출
      const isAuthorized = await userService.checkAuth();
      if (!isAuthorized) {
        store.dispatch('auth/logout');
        return next({ name: 'LoginPage' });
      }

      // admin 권한이 필요한 페이지 체크
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (!isAdmin) {
          // 권한이 없으면 기존 페이지에 머무르기 (네비게이션 취소)
          return next(false);
        }
      }

      return next();
    } catch (error) {
      // API 호출 실패 시 로그인 페이지로 리다이렉션
      store.dispatch('auth/logout');
      return next({ name: 'LoginPage' });
    }
  }

  next();
});
export default router;
